import nodeApi from '../utils/nodeApiClient';

const adminApi = {
  getTwoFactorSettings: () => nodeApi.get('/admin/settings/2fa'),
  updateTwoFactorSettings: (data) => nodeApi.put('/admin/settings/2fa', data),
  getForgotPasswordSetting: () => nodeApi.get('/admin/settings/forgot-password'),
  updateForgotPasswordSetting: (enabled) => nodeApi.put('/admin/settings/forgot-password', { enabled }),

  changeUserPassword: (userId, newPassword, confirmPassword) =>
    nodeApi.post(`/admin/users/${userId}/change-password`, { new_password: newPassword, confirm_password: confirmPassword }),

  listUserActionLogs: (params) => nodeApi.get('/admin/logs/user-actions', { params }),
  getUserActionLog: (id) => nodeApi.get(`/admin/logs/user-actions/${id}`),
  getUserActionLogFilters: () => nodeApi.get('/admin/logs/user-actions/filters'),

  listErrorLogs: (params) => nodeApi.get('/admin/logs/errors', { params }),
  getErrorLog: (id) => nodeApi.get(`/admin/logs/errors/${id}`),
  getErrorLogFilters: () => nodeApi.get('/admin/logs/errors/filters')
};

export default adminApi;
